export default __webpack_public_path__ + "static/media/v-chat.8cae646a.jpg";